<template>
  <div class="instructions">
    <p class="subtext">{{ $t('pay.instructions.subtext') }}</p>
    <ul>
      <li v-for="item of paragraphList" :key="item">
        <p :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
          {{ item }}
        </p>
      </li>
    </ul>
    <div class="line"></div>
  </div>
</template>

<script>
import i18n from '../../../i18n';

export default {
  dialogify: {
    title: i18n.t('pay.instructions.title'),
    showConfirmButton: true,
    position: 'bottom'
  },
  setup() {
    const paragraphList = [
      i18n.t('pay.instructions.paragraph1'),
      i18n.t('pay.instructions.paragraph2'),
      i18n.t('pay.instructions.paragraph3'),
      i18n.t('pay.instructions.paragraph4'),
      i18n.t('pay.instructions.paragraph5')
    ];
    return {
      paragraphList
    };
  }
};
</script>

<style lang="scss" scoped>
.instructions {
}
.subtext {
  text-align: center;
}
p {
  font-family: SourceHanSansCN;
  font-weight: 500;
  font-size: 12px; // rem转px，弹窗内容兼容PC
  color: #000000;
}
li > p {
  margin-top: 0.3rem;
}
.line {
  width: 100%;
  height: 1px;
  background: #8f8f8f;
  opacity: 0.2;
  margin-top: 0.5rem;
}
</style>
